/** Función vacía reutilizable para callbacks opcionales o valores por defecto. */
export const noop = (): void => {
  // intencionalmente vacía
};
